module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Code/Lock-circle-9eb83a92d3d16549ce4bf044871ca2f4.svg";